import makeActionCreator from 'make-action-creator'
import { NAMESPACE } from './constants'

export const userOrganizationHook = makeActionCreator(NAMESPACE + '/userOrganizationHook')
export const getOrganizations = makeActionCreator(NAMESPACE + '/getOrganization')
export const createOrganization = makeActionCreator(NAMESPACE + '/createOrganization')
export const updateUser = makeActionCreator(NAMESPACE + '/updateUser')
